import {SampleDeliveryType} from 'types/model/enumeration/SampleDeliveryType';
import {SelectOptions} from 'forms/components/BasicSelect';

export const sampleDeliveryTypeOptions: SelectOptions<SampleDeliveryType> = [
    {value: 'PERSONALLY', label: 'Osobně'},
    {value: 'COURIER', label: 'Dopravce - kurýr'},
    {value: 'LABORATORY_COLLECTION', label: 'Svoz laboratoře'},
    {value: 'MAIL', label: 'Poštou'},
];
